import axios from "@lib/axios";

export async function getCartById(cartId) {
  const res = await axios.get(`carts?id=${cartId}`);
  const cart = res.data.data;
  return cart;
}
